import { createCartMachine } from './machine';
let _machine = null;
export const getCartMachine = function() {
    if (_machine == null) {
        _machine = createCartMachine();
    }
    return _machine;
};
